import { Link } from 'react-router-dom';
import logo from 'assets/images/logo.svg';

export default function Nav() {
  return (
    <nav>
      <Link to='/'>
        <img src={logo} alt="Gisela Gonzalez Nutrición" width={180} height="auto" />
      </Link>
    </nav>
  );
}